import { render, staticRenderFns } from "./DWTFormGenerator.vue?vue&type=template&id=8ffc925e&scoped=true"
import script from "./DWTFormGenerator.vue?vue&type=script&lang=js"
export * from "./DWTFormGenerator.vue?vue&type=script&lang=js"
import style0 from "./DWTFormGenerator.vue?vue&type=style&index=0&id=8ffc925e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffc925e",
  null
  
)

export default component.exports